import { axiosInstance } from '../clients/axiosClient';
import { CounterResponse } from '../types/apiGeneratedTypes';
import { COUNTERS_API_PREFIX, API_V1_PREFIX } from '../utils/constants';

export const getDoctorsCount = async (): Promise<CounterResponse> => {
  try {
    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${COUNTERS_API_PREFIX}doctors`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getNutritionistsCount = async (): Promise<CounterResponse> => {
  try {
    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${COUNTERS_API_PREFIX}nutritionists`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const getNotesCount = async (): Promise<CounterResponse> => {
  try {
    const { data } = await axiosInstance.get(
      `${API_V1_PREFIX}${COUNTERS_API_PREFIX}notes`
    );

    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};